import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import LocalizedText from "../presentational/LocalizedText";
import { Input, FormGroup, Button, Intent } from '@careevolution/design-system';
import useTranslate from "../../hooks/useTranslate";
import { getIdentifier } from './utils';

interface IdentifierCheckProps {
  identifier: string;
  serverError: string;
  isLoading: boolean;
  subActionLink: string;
  validateIdentifier: (identifier: string) => void;
  onSetIdentifier: (identifier: string) => void;
}

const IdentifierCheck: React.FC<IdentifierCheckProps> = ({ identifier, serverError, isLoading, subActionLink, onSetIdentifier, validateIdentifier }) => {
  const translations = useTranslate(["participant-login-identifier-label", "participant-login-next-label"])

  const handleChangeIdentifier = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSetIdentifier(e.target.value)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    validateIdentifier(identifier)
    return false
  }

  useEffect(() => {
    var newIdentifier = getIdentifier();
    if (newIdentifier && newIdentifier !== identifier) {
      validateIdentifier(newIdentifier);
    }
  })

  return (
    <form className="login-action" onSubmit={handleSubmit}>
      <h1>
        <LocalizedText textKey="participant-login-identifier-check-title" />
      </h1>
      <p>
        <LocalizedText textKey="participant-login-identifier-check-text" />
      </p>
      {
        serverError && (
          <p className="server-error">{serverError}</p>
        )
      }
      <FormGroup
        className="login-field"
        label={translations["participant-login-identifier-label"]}
      >
        <Input
          className="autofocus"
          value={identifier}
          onChange={handleChangeIdentifier}
          disabled={isLoading}
          id="joinIdentifier"
          type="text"
          fullWidth={true}
          htmlAttributes={{
            autoCapitalize: "none",
            autoCorrect: "off",
            spellCheck: false,
          }}
        />
      </FormGroup>
      <Button
        onClick={handleSubmit}
        disabled={!identifier.length}
        className="primary-action"
        intent={Intent.primary}
        width='100%'
        loading={isLoading}
        type='submit'
      >
        <span dangerouslySetInnerHTML={{ __html: translations["participant-login-next-label"] }} />
      </Button>
      <p className="sub-action">
        <span><LocalizedText textKey="participant-login-join-existing-account" /></span> <Link to={subActionLink}><LocalizedText textKey="participant-login-sign-in-label" /></Link></p>
    </form>
  )
}

export default IdentifierCheck